"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleDates = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _select = require("./select");
var _layout = require("./layout");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DateWrapper = (0, _styledComponents["default"])(_layout.Box).attrs({
  cllassNmae: "flexi-single-dates"
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var SingleDates = function SingleDates(props) {
  var value = props.value,
    minDate = props.minDate,
    maxDate = props.maxDate,
    onMonthChange = props.onMonthChange,
    onDayChange = props.onDayChange,
    onYearChange = props.onYearChange,
    onDateChange = props.onDateChange;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    years = _useState2[0],
    setYears = _useState2[1];
  var _useState3 = (0, _react.useState)(_moment["default"].months().map(function (e, i) {
      return {
        value: i,
        label: e
      };
    })),
    _useState4 = _slicedToArray(_useState3, 1),
    months = _useState4[0];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    days = _useState6[0],
    setDays = _useState6[1];
  var dt = new Date();
  var currentYear = dt.getFullYear();
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedYear = _useState8[0],
    setSelectedYear = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedMonth = _useState10[0],
    setSelectedMonth = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedDay = _useState12[0],
    setSelectedDay = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    minimumDate = _useState14[0],
    setMinimumDate = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    maximumDate = _useState16[0],
    setMaximumDate = _useState16[1];
  (0, _react.useEffect)(function () {
    var allYears = [];
    for (var i = currentYear; i >= 1900; i--) {
      allYears.push({
        value: +i,
        label: +i
      });
    }
    setYears(allYears);
  }, [currentYear]);
  (0, _react.useEffect)(function () {
    var allDays = [];
    if (selectedYear !== null && selectedYear !== void 0 && selectedYear.value && selectedMonth !== null && selectedMonth !== void 0 && selectedMonth.value) {
      var daysOfCurrentMonth = new Date(selectedYear.value, Number(selectedMonth.value) + 1, 0).getDate();
      for (var i = 1; i <= daysOfCurrentMonth; i++) {
        allDays.push({
          value: +i,
          label: +i
        });
      }
      setDays(allDays);
      if (selectedDay !== null && selectedDay !== void 0 && selectedDay.value && (selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.value) > daysOfCurrentMonth) {
        setSelectedDay({
          value: daysOfCurrentMonth,
          label: daysOfCurrentMonth
        });
      }
    } else {
      for (var i = 1; i <= 31; i++) {
        allDays.push({
          value: +i,
          label: +i
        });
      }
      setDays(allDays);
    }
  }, [selectedYear, selectedMonth]);
  (0, _react.useEffect)(function () {
    if (props.value) {
      var valueDate = new Date(props.value);
      setSelectedYear({
        value: valueDate.getFullYear(),
        label: valueDate.getFullYear()
      });
      setSelectedMonth(months[valueDate.getMonth()]);
      setSelectedDay({
        value: valueDate.getDate(),
        label: valueDate.getDate()
      });
    } else {
      setSelectedYear(null);
      setSelectedMonth(null);
      setSelectedDay(null);
    }
  }, [props.value, months]);
  (0, _react.useEffect)(function () {
    if (props.minDate) {
      var min = new Date(props.minDate);
      setMinimumDate({
        year: min.getFullYear(),
        month: min.getMonth(),
        day: min.getDate()
      });
    }
    if (props.maxDate) {
      var max = new Date(props.maxDate);
      setMaximumDate({
        year: max.getFullYear(),
        month: max.getMonth(),
        day: max.getDate()
      });
    }
  }, [props.minDate, props.maxDate]);
  var formatDate = function formatDate(year, month, day) {
    if (year !== null && year !== void 0 && year.value && month !== null && month !== void 0 && month.value && day !== null && day !== void 0 && day.value) {
      var newDate = new Date(year.value, month.value, day.value);
      props.onDateChange(newDate);
    }
  };
  var handleYear = function handleYear(e) {
    if (!e.value) return;
    setSelectedYear(e);
    formatDate(e, selectedMonth, selectedDay);
    if (props.onYearChange) {
      props.onYearChange(e);
    }
  };
  var handleMonth = function handleMonth(e) {
    if (!e.value && e.value !== 0) return;
    setSelectedMonth(e);
    formatDate(selectedYear, e, selectedDay);
    if (props.onMonthChange) {
      props.onMonthChange(e);
    }
  };
  var handleDay = function handleDay(e) {
    if (!e.value) return;
    setSelectedDay(e);
    formatDate(selectedYear, selectedMonth, e);
    if (props.onDayChange) {
      props.onDayChange(e);
    }
  };
  var disableYearOptions = function disableYearOptions(year) {
    var formattedYear = year.map(function (y) {
      if (props.minDate && props.maxDate) {
        if (y.value < (minimumDate === null || minimumDate === void 0 ? void 0 : minimumDate.year) || y.value > (maximumDate === null || maximumDate === void 0 ? void 0 : maximumDate.year)) {
          return _objectSpread(_objectSpread({}, y), {}, {
            isDisabled: true
          });
        } else {
          return y;
        }
      } else if (props.minDate) {
        if (y.value < (minimumDate === null || minimumDate === void 0 ? void 0 : minimumDate.year)) {
          return _objectSpread(_objectSpread({}, y), {}, {
            isDisabled: true
          });
        }
        return y;
      } else if (props.maxDate) {
        if (y.value > (maximumDate === null || maximumDate === void 0 ? void 0 : maximumDate.year)) {
          return _objectSpread(_objectSpread({}, y), {}, {
            isDisabled: true
          });
        }
        return y;
      }
      return y;
    });
    return formattedYear;
  };
  var disableMonthOptions = function disableMonthOptions(year, month) {
    var formattedMonths = month.map(function (m) {
      if ((minimumDate === null || minimumDate === void 0 ? void 0 : minimumDate.year) === Number(year === null || year === void 0 ? void 0 : year.value)) {
        if (m.value >= (minimumDate === null || minimumDate === void 0 ? void 0 : minimumDate.month)) {
          return m;
        } else {
          return _objectSpread(_objectSpread({}, m), {}, {
            isDisabled: true
          });
        }
      } else if ((maximumDate === null || maximumDate === void 0 ? void 0 : maximumDate.year) === Number(year === null || year === void 0 ? void 0 : year.value)) {
        if (m.value <= (maximumDate === null || maximumDate === void 0 ? void 0 : maximumDate.month)) {
          return m;
        } else {
          return _objectSpread(_objectSpread({}, m), {}, {
            isDisabled: true
          });
        }
      } else {
        return m;
      }
    });
    return formattedMonths;
  };
  var disableDayOptions = function disableDayOptions(year, month, days) {
    var formattedDays = days.map(function (d) {
      if ((minimumDate === null || minimumDate === void 0 ? void 0 : minimumDate.year) === Number(year === null || year === void 0 ? void 0 : year.value)) {
        if ((minimumDate === null || minimumDate === void 0 ? void 0 : minimumDate.month) === Number(month === null || month === void 0 ? void 0 : month.value)) {
          if ((d === null || d === void 0 ? void 0 : d.value) >= (minimumDate === null || minimumDate === void 0 ? void 0 : minimumDate.day)) {
            return d;
          } else {
            return _objectSpread(_objectSpread({}, d), {}, {
              isDisabled: true
            });
          }
        }
      } else if ((maximumDate === null || maximumDate === void 0 ? void 0 : maximumDate.year) === Number(year === null || year === void 0 ? void 0 : year.value)) {
        if ((maximumDate === null || maximumDate === void 0 ? void 0 : maximumDate.month) === Number(month === null || month === void 0 ? void 0 : month.value)) {
          if ((d === null || d === void 0 ? void 0 : d.value) <= (maximumDate === null || maximumDate === void 0 ? void 0 : maximumDate.day)) {
            return d;
          } else {
            return _objectSpread(_objectSpread({}, d), {}, {
              isDisabled: true
            });
          }
        }
      }
      return d;
    });
    return formattedDays;
  };
  return /*#__PURE__*/_react["default"].createElement(DateWrapper, {
    margin: props.margin,
    pad: props.pad,
    display: props.display
  }, /*#__PURE__*/_react["default"].createElement(_select.Select, {
    placeholder: "Select Day...",
    value: selectedDay,
    onChange: function onChange(e) {
      return handleDay(e);
    },
    options: disableDayOptions(selectedYear, selectedMonth, days),
    spaceRight: props.spaceRight,
    width: props.width,
    spaceTop: props.spaceTop,
    spaceBottom: props.spaceBottom,
    height: props.height,
    fontColor: props.fontColor,
    pale: props.pale,
    error: props.error,
    label: props.DayLabel,
    block: props.block,
    caretBg: props.caretBg,
    color: props.color,
    elevate: props.elevate,
    disable: props.disableDay
  }), /*#__PURE__*/_react["default"].createElement(_select.Select, {
    placeholder: "Select Month...",
    value: selectedMonth,
    onChange: function onChange(e) {
      return handleMonth(e);
    },
    options: disableMonthOptions(selectedYear, months),
    width: props.width,
    spaceLeft: props.dayGap,
    spaceRight: props.yearGap,
    spaceTop: props.spaceTop,
    spaceBottom: props.spaceBottom,
    height: props.height,
    fontColor: props.fontColor,
    pale: props.pale,
    error: props.error,
    label: props.MonthLabel,
    block: props.block,
    caretBg: props.caretBg,
    color: props.color,
    elevate: props.elevate,
    disable: props.disableMonth
  }), /*#__PURE__*/_react["default"].createElement(_select.Select, {
    placeholder: "Select Year...",
    value: selectedYear,
    onChange: function onChange(e) {
      return handleYear(e);
    },
    options: disableYearOptions(years),
    width: props.width,
    spaceTop: props.spaceTop,
    spaceBottom: props.spaceBottom,
    height: props.height,
    fontColor: props.fontColor,
    pale: props.pale,
    error: props.error,
    label: props.YearLabel,
    block: props.block,
    caretBg: props.caretBg,
    color: props.color,
    elevate: props.elevate,
    disable: props.disableYear
  }));
};
exports.SingleDates = SingleDates;
SingleDates.propTypes = {
  value: _propTypes["default"].string,
  minDate: _propTypes["default"].string,
  maxDate: _propTypes["default"].string,
  onMonthChange: _propTypes["default"].func,
  onDayChange: _propTypes["default"].func,
  onYearChange: _propTypes["default"].func,
  onDateChange: _propTypes["default"].func,
  width: _propTypes["default"].bool,
  dayGap: _propTypes["default"].any,
  yearGap: _propTypes["default"].any,
  margin: _propTypes["default"].any,
  pad: _propTypes["default"].any,
  display: _propTypes["default"].string,
  disableYear: _propTypes["default"].bool,
  disableDay: _propTypes["default"].bool,
  disableMonth: _propTypes["default"].bool
};
SingleDates.defaultProps = {
  disableMonth: false,
  disableYear: false,
  disableDay: false,
  block: false,
  caretBg: "none",
  spaceLeft: false,
  spaceRight: false,
  height: 42,
  width: 130,
  elevate: false,
  pale: false,
  dayGap: "20px",
  yearGap: "20px",
  display: "flex"
};